import React from 'react';
import { IconArrow } from 'gatorcomponents';
import { ChartPaginationContext, useChartPaginationContext } from './ChartPaginationContext';
import { useChartPagination } from './useChartPagination';
import * as Styles from './ChartPagination.styles';

function Root({ data, pageSize, children }) {
  const value = useChartPagination(data, pageSize);
  return (
    <ChartPaginationContext.Provider value={value}>
      {children}
    </ChartPaginationContext.Provider>
  );
}

function PrevButton() {
  const { currentPage, goToPreviousPage } = useChartPaginationContext();
  const disabled = currentPage === 0;
  return (
    <Styles.Button
      type="button"
      onClick={goToPreviousPage}
      disabled={disabled}
      $disabled={disabled}
      aria-label="Previous page"
      data-testid="pagination-prev"
    >
      <IconArrow direction="left" />
    </Styles.Button>
  );
}

function NextButton() {
  const { currentPage, totalPages, goToNextPage } = useChartPaginationContext();
  const disabled = totalPages === 0 || currentPage === totalPages - 1;
  return (
    <Styles.Button
      type="button"
      onClick={goToNextPage}
      disabled={disabled}
      $disabled={disabled}
      aria-label="Next page"
      data-testid="pagination-next"
    >
      <IconArrow direction="right" />
    </Styles.Button>
  );
}

function PageIndicator() {
  const { currentPage, totalPages } = useChartPaginationContext();
  const displayPage = totalPages === 0 ? 0 : currentPage + 1;
  return (
    <Styles.PageIndicator data-testid="pagination-indicator">
      {displayPage}
      {' '}
      /
      {' '}
      {totalPages}
    </Styles.PageIndicator>
  );
}

function Bar() {
  const { totalPages } = useChartPaginationContext();
  if (totalPages <= 1) return null;
  return (
    <Styles.Bar data-testid="pagination">
      <PrevButton />
      <PageIndicator />
      <NextButton />
    </Styles.Bar>
  );
}

const ChartPagination = {
  Root,
  Bar,
  PrevButton,
  NextButton,
  PageIndicator,
};

export { ChartPagination, useChartPaginationContext };
export default ChartPagination;
